import React, { useState, useEffect } from 'react';
import { TrendingUp, Zap } from 'lucide-react';
import { getXPProgress } from '../../utils/gamificationManager';

const XPBar = ({ totalXP, showDetails = true, compact = false }) => {
  const [progress, setProgress] = useState({});
  const [animatedPercentage, setAnimatedPercentage] = useState(0);

  useEffect(() => {
    const progressData = getXPProgress(totalXP);
    setProgress(progressData);
    
    // Animate progress bar
    setTimeout(() => {
      setAnimatedPercentage(progressData.percentage);
    }, 100);
  }, [totalXP]);

  if (compact) {
    return (
      <div className="xp-bar-compact">
        <div className="xp-bar-fill" style={{ width: `${animatedPercentage}%` }}>
          <div className="xp-bar-shine"></div>
        </div>
        <div className="xp-bar-text">
          {progress.currentLevelXP || 0} / {progress.xpNeededForNextLevel || 0} XP
        </div>
      </div>
    );
  }

  return (
    <div className="xp-bar-container">
      {showDetails && (
        <div className="xp-bar-header">
          <div className="xp-info">
            <Zap size={20} color="#f39c12" />
            <span className="xp-label">Experience Points</span>
          </div>
          <div className="xp-total">
            <TrendingUp size={16} />
            <span>{progress.totalXP || 0} Total XP</span>
          </div>
        </div>
      )}

      <div className="xp-bar-wrapper">
        <div className="xp-bar">
          <div 
            className="xp-bar-fill" 
            style={{ width: `${animatedPercentage}%` }}
          >
            <div className="xp-bar-shine"></div>
          </div>
          <div className="xp-bar-text">
            {progress.currentLevelXP || 0} / {progress.xpNeededForNextLevel || 0} XP
          </div>
        </div>
        
        {showDetails && (
          <div className="xp-percentage">
            {Math.round(progress.percentage || 0)}%
          </div>
        )}
      </div>

      {showDetails && (
        <div className="xp-next-level">
          <span>{progress.xpNeededForNextLevel - progress.currentLevelXP || 0} XP to Level {(progress.level || 1) + 1}</span>
        </div>
      )}
    </div>
  );
};

export default XPBar;
